import {
    OrderLastType,
    ReviewsSelectedPopupType,
    WeightsType,
} from 'desktop/pages/success/types/types';
import {logWithSentry} from 'libs/sentry/sentry';

const logEmptyWeights = (): ReviewsSelectedPopupType => {
    logWithSentry(new Error("No weights were provided in 'orderLastRequest'"));
    return '';
};

/**
 * Returns active review popup on TYP based on weights received from backend side
 * @param {OrderLastType} reviewsData - reviews popup data
 * @returns {string} - selected popup
 */
export const selectPopup = ({weights}: OrderLastType): ReviewsSelectedPopupType => {
    if (!weights?.length) return logEmptyWeights();
    const weightsSum = weights.reduce(
        (sum: number, {weight}: WeightsType): number => sum + weight,
        0,
    );
    if (weightsSum === 0) return '';
    const randomWeight = Math.floor(Math.random() * (weightsSum - 1)) + 1;
    let selectedPopup: ReviewsSelectedPopupType = '';
    let weightsAccum = 0;
    weights
        .map<[ReviewsSelectedPopupType, number]>(({id, weight}) => [id, weight])
        .sort((item1, item2) => item2[1] - item1[1])
        .forEach(([id, weight]) => {
            weightsAccum += weight;
            if (randomWeight <= weightsAccum && selectedPopup === '') {
                selectedPopup = id;
            }
        });
    return selectedPopup;
};
